import { render, staticRenderFns } from "./AutoReports.vue?vue&type=template&id=2fe987f1&"
import script from "./AutoReports.vue?vue&type=script&lang=js&"
export * from "./AutoReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports